import { Block, type NodeType, type Value } from '@gitbook/slate';

import { createParagraph } from '../paragraph';
import { BLOCK_COLUMN, BLOCK_COLUMNS } from '../types';

export function createColumnsBlock(
    content: Array<Array<Block>> = [[createParagraph()], [createParagraph()]]
) {
    return Block.create({
        type: BLOCK_COLUMNS,
        isVoid: true,
        nodes: content.map((columnContent: Array<Block>) =>
            Block.create({
                type: BLOCK_COLUMN,
                nodes: columnContent,
            })
        ),
    });
}

/**
 * Return the currently selected columns block.
 */
export function getCurrentColumns(value: Value): { columns: Block; column: Block } | undefined {
    if (!value.startKey) {
        return;
    }

    const column = value.document.getClosest(
        value.startKey,
        (node: NodeType) => node.object === 'block' && node.type === BLOCK_COLUMN
    );

    if (!column || column.object !== 'block') {
        return;
    }

    const columns = value.document.getParent(column.key);

    if (!columns || columns.object !== 'block') {
        return;
    }

    return { columns, column };
}
